<template>
  <div class="product-box">
    <div class="tit-fixed">
      <div class="jarallax-container">
        <div class="cst_container_base">
          <slot name="model"></slot>
          <h2></h2>
          <slot name="model_y"></slot>
        </div>
      </div>
      <div class="cst_textbox_line"></div>
    </div>
    
    <div class="list-wrap">
      <div class="zhanwei"></div>
      <div class="wrap">
        <slot name="list"></slot>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      loading: true
    }
  }
  
};
</script>
  
  <style lang="scss"  scoped >
.product-box {
  position: relative;
  background: linear-gradient(rgba(28, 69, 135, 0.7), rgb(32, 18, 77)),
    url("../../assets/image/news_bg.jpg") center center / cover no-repeat;
    background-attachment: fixed;

  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #99aeff;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .wrap > div {
    overflow: hidden;
  }
}

.animate {
  opacity: 0;
}
.fadeInUpBig {
  animation: fadeInUpBig 1s;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}
</style>


// WEBPACK FOOTER //
// src/view/components/listPage.vue